<template lang='pug'>
v-responsive(:aspect-ratio='1920/700')
  v-app( style='font-family: Rubik, sans-serif !important ' )
    router-view( name='navegador').pt-10

    router-view.mt-4
    router-view( name='pie_de_pagina')

    v-snackbar( v-model="Ayudas.snackbarShow" :timeout='3000') 
      span {{ Ayudas.snackbarMessage }}
      v-btn( color='primary' text @click='Ayudas.snackbarShow=false' ) Ok
    
</template>
<script>
export default {
  created() {
    this.$store.dispatch('CMS/obtener')
    this.$store.dispatch('Imagenes/obtener_todos')
    this.$store.dispatch('Blog/obtener_todos')
    this.$store.dispatch('Etiquetas/obtener_todos')
  },
}

</script>
<style lang='sass' >
@font-face 
  font-family: 'Rubik'
  src: url("./app/assets/fonts/Rubik-Light.ttf") format("truetype")
  font-weight: 400


@font-face 
  font-family: 'Rubik'
  src: url("./app/assets/fonts/Rubik-Regular.ttf") format("truetype")
  font-weight: 500

@font-face 
  font-family: 'Rubik'
  src: url("./app/assets/fonts/Rubik-Medium.ttf") format("truetype")
  font-weight: 600

@font-face 
  font-family: 'Rubik'
  src: url("./app/assets/fonts/Rubik-Bold.ttf") format("truetype")
  font-weight: 700

@font-face 
  font-family: 'Rubik'
  src: url("./app/assets/fonts/Rubik-Black.ttf") format("truetype")
  font-weight: 800


iframe
  max-width: 100%!important

p, span, a,.display-1, .display-2, .display-3, .display-4, .v-application .title,  .v-application .display-1
  font-family: 'Rubik', sans-serif!important
.icono-international
  position: relative
  &:before
    content: ''
    top: 0
    left: 0
    background: #cf0001!important
    position: absolute
    clip-path:  polygon(100% 0%, 50% 0%, 50% 100%, 0% 100%, 0% 50%, 100% 50%)
    width: 20px
    height: 20px
    transition: .5s all
    opacity: 1
    border-radius: 0!important
  &.icono-blanco
    &:before
      background: #ffffff!important
  &.icono-grande
    &:before
      width: 40px
      height: 40px
  &.hover
    &:before
      opacity: .00!important
    &:hover
      &:before
        opacity: 1!important
    &.activo
      &:before
        opacity: 1!important
</style>